module.exports = __webpack_public_path__ + "img/sticker_13.d2b8aee9.svg";